import React, { FC } from 'react';
import { Col, Grid, Row } from 'antd';
import { ArtworkCard, TextHeadingSection } from 'components';
import ArtworkGrid from 'components/ArtworkGrid/ArtworkThumbnail'

export const SectionUpcoming: FC = () => {
	const { lg } = Grid.useBreakpoint();

	// populate with artworks to pass into grid
	let artworks = [];

	return (
		<Col>
			<Col>
				<TextHeadingSection secondary>Upcoming lots</TextHeadingSection>
				<p>View artwork which will be for sale in the live auction</p>
			</Col>
			<Row>
				{artworks?.length > 0 ?
					<ArtworkGrid
						items={artworks}
					/>
					: "No upcoming lots"}
			</Row>
		</Col>
	);
};
